import script from "./InputMixin.vue?vue&type=script&lang=js"
export * from "./InputMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__